import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import RecycleIcon from "@redotech/redo-icons/recycle.svg";
import WithdrawalsIcon from "@redotech/redo-icons/x-circle.svg";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { recordListHref } from "../../record-links/record-links";
import type { JumpToDestination } from "./record-home-source";

export const RECYCLE_DESTINATION: JumpToDestination = {
  type: "recycle",
  Icon: RecycleIcon,
  availability: {
    capabilities: ["recycling"],
    permissions: [ReturnsAndClaimsPermissions.MANAGE_RECYCLING_REQUESTS],
  },
  label: (t) => t("Recycle"),
  href: (routes) =>
    recordListHref(routes.returnsBaseUrl, ReturnTypeEnum.RECYCLE),
};

export const WITHDRAWALS_DESTINATION: JumpToDestination = {
  type: "withdrawals",
  Icon: WithdrawalsIcon,
  availability: {
    capabilities: ["withdrawals"],
    permissions: [ReturnsAndClaimsPermissions.MANAGE_WITHDRAWAL_REQUESTS],
  },
  label: (t) => t("Withdrawals"),
  href: (routes) =>
    recordListHref(routes.returnsBaseUrl, ReturnTypeEnum.WITHDRAWAL),
};
